import { TableLayout } from "../components/table-layout/TableLayout";

export const IsolatedTableLayoutPage = () => {

    return (
        <main
            id="table-layout-page"
            className={`page-container p-r`}
            aria-live="assertive"
        >
            <div className="df jcsb aic w-100 h-100 content">
                <TableLayout isolated showAvailability={false} />
            </div>
        </main>
    )
};
